import { appVersion } from '@/application/constants/env-variables';
import { createId } from '@/components/uikit/type-utils';
import { InternalAxiosRequestConfig } from 'axios';

// it's constant while the app is running, and different after app restarts
export const sessionId = `${createId()}-${createId()}-${createId()}`;

/**
 * Intercepts all HTTP calls via axios and adds a session-id header.
 */
export const sessionAxiosInterceptor = (config: InternalAxiosRequestConfig) => {
  config.headers = config.headers ?? {};
  config.headers['ClientSession'] = sessionId;
  config.headers['ClientVersion'] = appVersion();
  config.headers['ClientPlatform'] = 'web';
  return config;
};
